import { createSlice } from '@reduxjs/toolkit';
import { fetchApiData } from './accountthunk';

const initialState = {
  data: null,
  loading: false,
  error: null,
  orgName: null,   // 👈 new state
  orgEntity: null,   // 👈 new state
};

const accountSlice = createSlice({
  name: 'apiData',
  initialState,
  reducers: {
    clearData: (state) => {
      state.data = null;
      state.error = null;
      state.orgName = null;   // 👈 clear orgName also
      state.orgEntity = null;   // 👈 clear orgName also
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;

        // 👇 safely pick orgName from response
        state.orgName = action.payload?.orgInfo?.orgName || null;
        state.orgEntity = action.payload?.orgInfo?.entities || null;
      })
      .addCase(fetchApiData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearData } = accountSlice.actions;
export default accountSlice.reducer;
